import React from 'react';
import moment from 'moment';

//-------------------------------------------------------------------------------------------------------------------

class ReportResults extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tooltipsVisible: {},
            version: 1
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (nextProps.version != this.props.version || nextState.version != this.state.version);
    }

    toggleTooltip(rowIndex, colIndex) {
        const tooltipsVisible = { ...this.state.tooltipsVisible };
        const key = `${rowIndex}-${colIndex}`;
        if (tooltipsVisible[key]) {
            delete tooltipsVisible[key];
        } else {
            tooltipsVisible[key] = true;
        }
        this.setState({
            tooltipsVisible,
            version: this.state.version + 1
        });
    }

    render() {
        const { results } = this.props;

        // Render
        return (
            <div className="sticky-table-container scrolling">
                <table className="table report-table sticky-table">
                    <thead>
                        <tr>
                            {results.columns.map(rc => {
                                const style = {};
                                if (rc.width) {
                                    style.minWidth = rc.width;
                                    style.width = rc.width;
                                }
                                return (
                                    <th key={rc.code} className={rc.headerClass || ''} title={rc.tooltip1} style={style}>
                                        {rc.name}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {results.rows.map((rr, rowIndex) =>
                            <tr key={rowIndex} className={rr['_ClassName'] || ''}>
                                {results.columns.map((rc, colIndex) => {
                                    const style = {};
                                    if (rc.width) {
                                        style.minWidth = rc.width;
                                        style.width = rc.width;
                                    }
                                    return (
                                        <td key={colIndex} style={style}>
                                            {this.renderValue(rr[rc.code], rc.type, rowIndex, colIndex)}
                                        </td>
                                    );
                                })}
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    }

    renderValue(value, type, rowIndex, colIndex) {
        const {
            tooltipsVisible
        } = this.state;

        if (!value) {
            return '';
        }

        switch (type) {
            case 'MultiLineText':
                return value.split(/,/).map((v, index) =>
                    <div key={index}>{v}</div>
                );
            case 'Date':
                const dateMoment = (value ? moment(value) : null);
                if (dateMoment) {
                    if (dateMoment.isValid()) {
                        return dateMoment.format('DD/MM/YYYY');
                    } else {
                        return value;
                    }
                } else {
                    return '';
                }
            case 'Month':
                return moment(value).format('MMM YYYY');
            case 'Bool':
                return <span className="fa-solid fa-check"></span>;
            case 'URL':
                return <a href={value} target="_blank" className="btn btn-secondary w-100">View</a>;
            case 'Tooltip':
                return (<>
                    <button className="btn btn-primary" onClick={() => this.toggleTooltip(rowIndex, colIndex)}>
                        <span className="far fa-comment-dots" title={value} />
                    </button>

                    {tooltipsVisible[`${rowIndex}-${colIndex}`] &&
                        <div className="report-tooltip">
                            {value}
                        </div>
                    }
                </>);
        }
        return value;
    }
}

export default ReportResults;
